import { useAuth } from "../AuthProvider";
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import axios from "axios";
import { baseUrl_SPB } from "../BaseUrl";
import { MenuItem, Select, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";
import './Checkout.scss';
import { cancelsubscription, retrievesubsciptiondetails } from "../services/stripe/StripeServices";
import { fetchAuthSession } from 'aws-amplify/auth';
import DraggableDialog from "./ConfirmationDialog";
import { Circles } from "react-loader-spinner";
import PricingOptions from "./plans/PricingOptions";
export default function Checkout(props) {
  const navigate = useNavigate();
  const authContext = useAuth();
  const [formData, setFormData] = useState({ productId: 'prod_QpKdTkbGefON83', email: '' });

  const [hasSubscription, setHasSubscription] = useState(false);
  const [subscriptionCancelled, setSubscriptionCancelled] = useState(false);
  const [checkoutStatus, setCheckoutStatus] = useState('');
  const [changePlan, setChangePlan] = useState('');
  const [openDraggableDialog, setOpenDraggableDialog] = useState(false);
  const [processing, setProcessing] = useState(false);

  const retrieveSubscription = (token) => {


    retrievesubsciptiondetails(token).then(subDetails => {
      console.log("Zul is here");
      if (subDetails) {
        console.log(subDetails);
        setFormData({
          ...formData,
          subProductId: subDetails.stripeProductId,
          subProductName: subDetails.productName,
          trialEndDate: subDetails.trialEndDate,
          currentPeriodEnd: subDetails.currentPeriodEnd,
          currentPeriodEndString: subDetails.currentPeriodEndString
        });
        const today = new Date();
        console.log(Date.parse(subDetails.currentPeriodEnd));
        console.log(subDetails.currentPeriodEnd);
        if (today < Date.parse(subDetails.currentPeriodEnd)) {
          console.log("Inside date com");
          setHasSubscription(true);
        } else {
          setHasSubscription(false);
        }
      }
      setProcessing(false);

    })
      .catch((error) => {
        setProcessing(false);
        alert("Something went wrong. Please urgently contact our support team");
        console.error('Error:', error);
      });



  }
  useEffect(() => {
    async function completeSubscriptionProcess() {
      setProcessing(true);
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const paramValue = urlParams.get('session_id');
      const statusValue = urlParams.get('status');


      if (paramValue) {
        if (statusValue === 'failed') {
          console.log("I am inside");
          setCheckoutStatus(statusValue);
          setProcessing(false);
        } else {
          fetchAuthSession().then((session) => {

            let tokenv = session.tokens.accessToken.toString();

            fetch(`${baseUrl_SPB}/api/v1/subscribe/postpurchasesuccess`, {

              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + tokenv,

              },
              body: paramValue
            })
              .then(response => {
                console.log("I am insie retrieve subs");
                retrieveSubscription(tokenv);
                setProcessing(false);
              })
              .catch((error) => {
                setProcessing(false);
                alert("Something went wrong. Please urgently contact our support team");
                console.error('Error:', error);
              });

          });
        }

      } else {
        retrieveSubscription(authContext.token);
      }


    }
    completeSubscriptionProcess();
    //const jsonResponse = await response.json();
    //console.log(jsonResponse);

  }, [formData.productName]);


  const handleSubmit = async (productId) => {
    const postData = {
      productId: productId,
    }
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    setProcessing(true);
    console.log(authContext.token);
    const tokenv = authContext.token.toString();
    const response = await fetch(`${baseUrl_SPB}/api/v1/subscribe/create-checkout-session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + tokenv,

      },
      body: JSON.stringify(postData)
    })
    setProcessing(false);
    const jsonResponse = await response.json();


    window.location.replace(jsonResponse.urlProcess);
  };

  const handleChange = (event) => {
    setFormData({ ...formData, productId: event.target.value });
  };

  const oncancelInitiate = async () => {
    setOpenDraggableDialog(true);
  }
  const oncancel = async () => {
    setProcessing(true);
    cancelsubscription(authContext.token).then(subDetails => {

      if (subDetails) {
        setFormData({
          ...formData,
          subProductId: subDetails.stripeProductId,
          subProductName: subDetails.productName,
          trialEndDate: subDetails.trialEndDate,
          currentPeriodEnd: subDetails.currentPeriodEnd,
          currentPeriodEndString: subDetails.currentPeriodEndString
        });
        setSubscriptionCancelled(true);
        setHasSubscription(false);

      }
    });
    setProcessing(false);
  }
  return (


    <div >
      {checkoutStatus === 'failed' &&
        <div>You cancelled the purchase of the plan</div>}
      {hasSubscription &&
        <div className="lcContainer">
          <div className="lcContainerChildFirst">Your are subscribed for <span className="spanText">{formData.subProductName}</span> plan which is active until {formData.currentPeriodEndString}</div>
          <Button className="buttonField lcContainerChild2nd" variant="contained" onClick={() => setChangePlan(true)}>Change Plan</Button>
          <Button className="buttonField lcContainerChild2nd" variant="outlined" onClick={() => oncancelInitiate()}>Cancel</Button>
        </div>
      }

      {subscriptionCancelled &&
        <div className="lcContainer">
          <div className="lcContainerChildFirst">Your subscription is cancelled</div>
        </div>
      }

      {((!hasSubscription || subscriptionCancelled || changePlan) && !processing) &&
        <div className="lcWrapper">
          <div className="lcWrapperChild">Available plans to choose from:</div>
          <PricingOptions handleSubmit={handleSubmit} hasSubscription={hasSubscription} />
        </div>}
      <DraggableDialog oncancel={oncancel} open={openDraggableDialog} setOpenDraggableDialog={setOpenDraggableDialog} />
      {processing ?
        <div class="loading-state">
          <Circles
            height="60"
            width="60"

            color="blue"
            ariaLabel="audio-loading"
            wrapperStyle={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}
            visible={true}
          />
        </div> : ''}
    </div>


  )
}